import type { ReactNode } from "react";

/**
 * Shared disclosure rows under the welcome card — "recorded for research"
 * + "one conversation per person". Verbatim port from the prototype.
 */
export function InterviewDisclaimers() {
  return (
    <ul className="mt-6 space-y-2.5">
      <TipRow
        title="Headphones work best"
        body="On loud speakers Lea can hear herself and get confused — earbuds keep the conversation clean."
        icon={<HeadphonesIcon />}
      />
      <TipRow
        title="Recorded for research"
        body="Reviewed only by our research team. Your words shape Leaply — nothing is shared outside."
        icon={<RecordIcon />}
      />
      <TipRow
        title="One conversation per person"
        body="You'll do this once with this email. Take your time."
        icon={<PersonIcon />}
      />
    </ul>
  );
}

function TipRow({
  title,
  body,
  icon,
}: {
  title: string;
  body: string;
  icon: ReactNode;
}) {
  return (
    <li className="flex items-start justify-between gap-3 rounded-2xl bg-surface-muted/80 px-5 py-3.5">
      <div className="min-w-0">
        <p className="text-body-s font-semibold text-surface-ink mb-0.5">
          {title}
        </p>
        <p className="text-body-s text-surface-subtle leading-snug">{body}</p>
      </div>
      <span
        aria-hidden
        className="inline-flex items-center justify-center w-7 h-7 shrink-0 rounded-full bg-surface text-surface-subtle mt-0.5"
      >
        {icon}
      </span>
    </li>
  );
}

function HeadphonesIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden>
      <path
        d="M3 12V8a5 5 0 0 1 10 0v4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <rect x="2" y="10" width="2.6" height="4" rx="1" fill="currentColor" />
      <rect x="11.4" y="10" width="2.6" height="4" rx="1" fill="currentColor" />
    </svg>
  );
}

function RecordIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden>
      <circle
        cx="8"
        cy="8"
        r="6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <circle cx="8" cy="8" r="2.5" fill="currentColor" />
    </svg>
  );
}

function PersonIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden>
      <circle
        cx="8"
        cy="5.5"
        r="2.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M3 14c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
